import React, { useState, useEffect } from 'react';

const Loader = () => {
  const [isFinished, setIsFinished] = useState(false);

  useEffect(() => {
    // ننتظر 3.5 ثانية (مدة الأنيميشن الكلية) ثم نزيل اللودر
    const timer = setTimeout(() => {
      setIsFinished(true);
    }, 7000); 

    return () => clearTimeout(timer);
  }, []);

  if (isFinished) return null;

  return (
    <div className="loader-screen">
      <h1 className="gym-name">
        <span className="hulk-text">MY</span>
        <span className="letter-l">
          <span className="letter-l-char">A</span>
          {/* <i className="fa-solid fa-dumbbell dumbbell-fa-icon"></i> */}
          <i className="fa-solid fa-shirt dumbbell-fa-icon"></i>
        </span>
        <span className="hulk-text">M</span>
      </h1>
    </div>
  );
};

export default Loader;